<template>
  <div class="view-all-mandatory-checklist">
    <cs-button
      id="view-all-mandatory-checklist--view-checklist"
      label="View Checklist"
      :disabled="dialog"
      @click.stop="dialog = true"
    ></cs-button>
    <cs-form-dialog
      id="dlg-view-all-mandatory-checklist"
      v-model="dialog"
      body-id="dlg-view-all-mandatory-checklist-body"
      heading="Complete Checklist"
    >
      <template #cs-form-dialog-content>
        <div class="checklist-content">
          <v-list v-for="(checklist, index) in mandatoryChecklist" :key="index" slim>
            <v-list-subheader>
              <h1>{{ checklist.title }}</h1>
            </v-list-subheader>
            <v-list v-for="(item, itemIndex) in getItemsByTitle(checklist)" :key="itemIndex">
              <div v-if="item.contentType === 'form-group'">
                <v-list-subheader v-if="item.label.indexOf(removeLabel) !== 0">
                  <stb-markdown :source="item.label" />
                </v-list-subheader>
                <div v-for="(option, childIndex) in item.children" :key="childIndex">
                  <checklist-item
                    v-if="'checkbox' === option.contentType"
                    v-model="option.ticked"
                    :checklist-item="option"
                    :label="option.label"
                    disabled
                    :checkbox-id="`view-all-mandatory-checklist--${String(
                      checklist.title
                    ).replaceAll(' ', '-')}--form-group-checkbox--${childIndex}`"
                    :comment-btn-id="`view-all-mandatory-checklist--${String(
                      checklist.title
                    ).replaceAll(' ', '-')}--form-group-checkbox-comment--${childIndex}`"
                    @markdown-error="markdownError = true"
                  />
                  <checklist-item-comment
                    v-if="'checkbox' !== option.contentType"
                    :checklist-item="option"
                    :comment-disabled="true"
                    :comment-btn-id="`view-all-mandatory-checklist--${String(
                      checklist.title
                    ).replaceAll(' ', '-')}--form-group-checkbox-comment--${childIndex}`"
                  >
                  </checklist-item-comment>
                </div>
              </div>
              <div v-else-if="item.contentType === 'checkbox'">
                <checklist-item
                  v-model="item.ticked"
                  :checklist-item="item"
                  :label="item.label"
                  disabled
                  :checkbox-id="`view-all-mandatory-checklist--${String(checklist.title).replaceAll(
                    ' ',
                    '-'
                  )}--checkbox--${itemIndex}`"
                  :comment-btn-id="`view-all-mandatory-checklist--${String(
                    checklist.title
                  ).replaceAll(' ', '-')}--checkbox-comment--${itemIndex}`"
                  @markdown-error="markdownError = true"
                />
              </div>
              <div v-else>
                <v-list-subheader>
                  <stb-markdown :source="item.label" />
                </v-list-subheader>
                <checklist-item-comment
                  :checklist-item="item"
                  :comment-disabled="true"
                  :comment-btn-id="`view-all-mandatory-checklist--${String(
                    checklist.title
                  ).replaceAll(' ', '-')}--content-type-comment--${index}`"
                >
                </checklist-item-comment>
              </div>
            </v-list>
          </v-list>
        </div>
      </template>
    </cs-form-dialog>
  </div>
</template>

<script>
import * as types from '@/store/mutationTypes';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import StbMarkdown from '@/components/StbMarkdown';
import ChecklistItemComment from './ChecklistItemComment';
import ChecklistItem from './ChecklistItem';

export default {
  name: 'ViewAllMandatoryChecklist',

  components: {
    StbMarkdown,
    ChecklistItemComment,
    ChecklistItem
  },
  data: () => ({
    dialog: false,
    removeLabel: 'The following risk controls have been selected by default.'
  }),
  computed: {
    ...mapState({
      mandatoryChecklist: (state) => state.common.excursionDc.mandatoryChecklist
    })
  },
  async mounted() {
    const { mandatoryChecklist } = this.$store.state.common.excursionDc;
    this.$store.commit(types.COMMON_SET_MANDATORY_LOADING_COMPLETED, true);

    if (!mandatoryChecklist || mandatoryChecklist.length === 0) {
      const argHash = {
        stbApiAdapter: this.$app.stbApiAdapter,
        store: this.$store,
        queryParam: this.$route.query
      };
      await this.$store.dispatch('common/getMandatoryChecklist', argHash);
    } else {
      this.$store.commit(types.COMMON_SET_MANDATORY_LOADING_COMPLETED, false);
    }
  },
  methods: {
    getItemsByTitle(obj) {
      if (!obj.Strategy) {
        return [];
      }

      const checklist = obj.Strategy.data[Object.keys(obj.Strategy.data)].children;
      const result = cloneDeep(checklist);
      return result;
    }
  }
};
</script>
<style scoped>
.checklist-content {
  padding: 0 10px;
}

.checklist-content .header {
  color: #c80063;
  width: 100%;
}

.checklist-content .v-list-item {
  height: auto;
  align-items: flex-start;
  padding-bottom: 12px;
}

.checklist-content .content {
  white-space: normal;
  height: auto;
}

.checklist-content :deep(.v-list-subheader__text) {
  width: 100% !important;
}

.checklist-content h1 {
  color: gray;
  border-bottom: 3px solid #ff7f32;
  width: 100% !important;
}

.checklist-content .v-list-item__action {
  min-width: 30px;
  margin: 0 8px 0 0 !important;
  padding: 0 !important;
}

.checklist-content .v-list-item__content {
  margin: 0 !important;
  padding: 0 !important;
}

.checklist-content .v-input__slot {
  min-height: auto;
  height: auto;
}

.checklist-content .v-list-subheader {
  font-size: 16px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.checklist-content .v-input--selection-controls__ripple:before {
  left: unset;
  right: unset;
  top: unset;
}

.checklist-content .v-list-item__content label {
  margin-bottom: 5px;
}
</style>
